'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerDecorator = routerDecorator;
function routerDecorator($rootScope, $state, Auth) {
  'ngInject';

  $rootScope.$on('$stateChangeStart', function (event, next) {
    if (!next.authenticate) {
      return;
    }

    if (typeof next.authenticate === 'string') {
      Auth.hasRole(next.authenticate).then(function (has) {
        if (has) {
          return;
        }

        event.preventDefault();
        return Auth.isLoggedIn().then(function (is) {
          $state.go(is ? 'calendar' : 'main');
        });
      });
    } else {
      Auth.isLoggedIn().then(function (is) {
        if (is) {
          return;
        }

        event.preventDefault();

        $state.go('main');
      });
    }
  });
}


// WEBPACK FOOTER //
// ./client/components/auth/router.decorator.js